module.exports = __webpack_public_path__ + "images/psp/militarySizeGuide/militaryBox2.svg";